import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
// import Loading from "../../components/admin/childComponents/appComponents/Loading";
// import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Footer() {
  const navigate = useNavigate("");
  const [allSection, setAllSection] = useState([]);
  
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    input: {
      searchDatabase: "",
    },
    textArea: {
      //message: "",
    },
    select: {
      //message: "",
    },
  });

  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData("input", name, value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}footer-counts`);
      setAllSection(response.data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const handleSearch = async (event) => {
    event.preventDefault();
    setLoading(true);

    navigate(`/searches/${formData.input.searchDatabase}`);
  };

  return (
    <>
      <div className="footer-newsletter">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-6">
              <h3 className="text-white">Search Archive </h3>
              <p>
                Looking for something specific? Use the search bar to find
                archived news and documents
              </p>
              <form
                onSubmit={handleSearch}
                className="php-email-form"
                data-aos="fade-up"
                data-aos-delay={200}
              >
                <div className="newsletter-form">
                  <input
                    type="input"
                    name="searchDatabase"
                    required
                    placeholder="Type a Search Word"
                    onChange={handleChange}
                  />
                  <input
                    type="submit"
                    defaultValue="Search"
                    aria-label="Subscribe to newsletter"
                    style={{ backgroundColor: "#0d6efd", color: "#ffffff" }}
                  />
                </div>
                {/* <div className="loading">Loading</div>
                <div className="error-message" />
                <div className="sent-message">
                  Your subscription request has been sent. Thank you!
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-5">
            <div className="col-lg-12 col-md-12 footer-about">
              <Link to="index.html" className="d-flex align-items-center">
                <span className="sitename">CONTACT</span>
              </Link>
              <div className="footer-contact pt-3">
                <div class="d-flex align-items-start">
                  <div class="me-4">
                    <i class="fa fa-map-marker"></i>
                  </div>
                  <div>
                    FEDERAL MINISTRY OF HOUSING AND URBAN DEVELOPMENT
                    <br />
                    Headquarters, Mabushi, Abuja
                  </div>
                </div>
                <div class="d-flex align-items-start mt-3">
                  <div class="me-4">
                    <i class="fa fa-envelope"></i>
                  </div>
                  <div>
                    info@fmhud.gov.ng <br />
                    hmregistry@fmhud.gov.ng <br />
                    hmsregistry@fmhud.gov.ng <br />
                    psregistry@fmhud.gov.ng
                  </div>
                </div>
                <div class="d-flex align-items-start mt-3">
                  <div class="me-4">
                    <i class="fa fa-phone"></i>
                  </div>
                  <div>
                    Nigeria: 234-(0)- 8 061 7433 13
                    <br />
                    Call Time: 8 - 4pm Daily, Monday to Friday
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 pt-5">
              <h4>Follow Us</h4>
              <div className="social-links d-flex">
                <Link
                  to="https://twitter.com/FMHUD_NG"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit FMHUD Twitter page"
                  title="Twitter"
                >
                  <i className="fa-brands fa-x-twitter" />
                </Link>
                <Link
                  to="https://www.facebook.com/FMHUDNG"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit FMHUD Facebook page"
                  title="Facebook"
                >
                  <i className="fa-brands fa-facebook-f" />
                </Link>
                <Link
                  to="https://www.linkedin.com/in/FMHUDNG"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit FMHUD LinkedIn page"
                  title="LinkedIn"
                >
                  <i className="fa-brands fa-linkedin-in" />
                </Link>
                <Link
                  to="https://www.instagram.com/fmhudng"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit FMHUD Instagram page"
                  title="Instagram"
                >
                  <i className="fa-brands fa-instagram" />
                </Link>
                <Link
                  to="https://www.youtube.com/channel/UC3P5Hj-gEdcf-cNJS8pAQ2g"
                  loading="lazy"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit FMHUD YouTube channel"
                  title="YouTube"
                >
                  <i className="fa-brands fa-youtube" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-5 ">
            <div className="col-lg-12 col-md-12 footer-links">
              <h4>Other Agencies</h4>

              <ul>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://fha.gov.ng`} target="_blank">
                    Federal Housing Authority
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://www.fmbn.gov.ng`} target="_blank">
                    Federal Mortgage Bank of Nigeria
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://surcon.gov.ng`} target="_blank">
                    Surveyors Registration Council of Nigeria
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`http://osgof.gov.ng`} target="_blank">
                    Office of the Surveyor General of the Federation
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://www.arconigeria.gov.ng`} target="_blank">
                    Architects Registration Council of Nigeria
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://www.corbon.gov.ng/`} target="_blank">
                    Council of Registered Builders of Nigeria
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://qsrbn.gov.ng`} target="_blank">
                    Quantity Surveyors Registration Board of Nigeria
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://toprecng.org`} target="_blank">
                    Town Planners Registration Council of Nigeria
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://www.niesv.org.ng`} target="_blank">
                    Nigerian Institution of Estate Surveyors and Valuers
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://www.esvarbon.gov.ng`} target="_blank">
                    Estate Surveyors and Valuers Registration Board of Nigeria
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-lg-12 col-md-12 footer-links">
              <h4>Other Agencies</h4>

              <ul>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`/Legal Disclaimer and Privacy Policy/15`}>
                    Legal Disclaimer &amp; Privacy Policy
                  </Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`/F.A.Q/38`}>FAQ</Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`/Disclaimer/18`}>Disclaimer</Link>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-right me-2" />
                  <Link to={`https://webmail.fmhud.gov.ng`} target="_blank">
                    Mail
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-5">
            <div className="col-lg-12 col-md-12 footer-links">
              <h4>Categories</h4>
              <ul>
                <li>
                  <i className="fa-solid fa-caret-right me-2" />
                  <div className="row col-sm-12">
                    <Link to="/read/title_show_echo_01zz" className="d-flex">
                      <div className="col-sm-8">LATEST PRESS</div>
                      <div className="col-sm-4">{allSection.latest_news}</div>
                    </Link>
                  </div>
                </li>
                <li>
                  <i className="fa-solid fa-caret-right me-2" />
                  <div className="row col-sm-12">
                    <Link to="/read/title_show_echo_01" className="d-flex">
                      <div className="col-sm-8">PUBLIC ANNOUNCEMENT</div>
                      <div className="col-sm-4">{allSection.public_announcement}</div>
                    </Link>
                  </div>
                </li>
                <li>
                  <i className="fa-solid fa-caret-right me-2" />
                  <div className="row col-sm-12">
                    <Link to="/read/title_show_echo_02" className="d-flex">
                      <div className="col-sm-8">OTHER NEWS</div>
                      <div className="col-sm-4">{allSection.other_news}</div>
                    </Link>
                  </div>
                </li>
                <li>
                  <i className="fa-solid fa-caret-right me-2" />
                  <div className="row col-sm-12">
                    <Link to="/read/title_show_echo_03" className="d-flex">
                      <div className="col-sm-8">SPEECHES</div>
                      <div className="col-sm-4">{allSection.speeches}</div>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-lg-12 col-md-12 footer-links">
              <h4>Our Location</h4>
              <iframe
                title="Google Map Location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3939.8214274164316!2d7.453387!3d9.080027!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b0051bb9dff%3A0xb06406a0d062ec36!2sFederal%20Ministry%20of%20Housing%20and%20Urban%20Development!5e0!3m2!1sen!2sng!4v1777032230675!5m2!1sen!2sng"
                frameBorder={0}
                style={{ border: 0, width: "100%", height: 270 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">
            FEDERAL MINISTRY OF HOUSING AND URBAN DEVELOPMENT
          </strong>{" "}
          <span>All Rights Reserved</span>
        </p>
        <div className="credits">
          {/* All the links in the footer should remain intact. */}
          {/* You can delete the links only if you've purchased the pro version. */}
          {/* Licensing information: https://bootstrapmade.com/license/ */}
          {/* Purchase the pro version with working PHP/AJAX contact form: [buy-url] */}
          Designed by{" "}
          <Link to="https://cviewsoft.com.ng" target="_blank">
            CViewSoft Ltd
          </Link>
        </div>
      </div>
    </>
  );
}

export default Footer;
